import { UserApi } from '@intelingu/core/api/UserApi';
import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import withTranslation from "@intelingu/core/utils/withTranslation";
import {COMMON_NS} from "@intelingu/core/constants/base.constants";

interface ConfirmEmailComponentProps {
    t?;
}

@withTranslation(COMMON_NS)
@observer export class ConfirmEmailComponent extends Component<ConfirmEmailComponentProps, any> {

    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(UserApi) userApi: UserApi;

    @observable resent = false;

    @action.bound resend(e) {
        e.preventDefault();
        this.userApi.resendConfirmation();
        this.resent = true;
    }

    render() {
        const { t } = this.props;

        return <div className={'col-12 p-0'}>
            <div className={'confirm-email-alert'}>
                <h1 style={{ fontSize: 28 }}>es kann FAST losgehen…</h1>
                <p>Öffne dein Postfach und klicke auf den Bestätigungs-Link, um mit Intelingu sofort durchzustarten.</p>
                <p style={{ fontSize: 13 }}>(Keine Mail erhalten? Dann schaue bitte im Spam-Ordner nach, oder <a href={''} onClick={this.resend}>klicke hier</a>, um einen neuen Bestätigungs-Link zu erhalten)</p>

                { this.resent && <p>{ t('confirmEmailSent') }</p> }
            </div>
        </div>
    }

}
